import { Input, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { DEAFAULT_PAGESIZE } from "../../../../app/modules/Configuration/pages/Configuration/Sounds";
import { useMobileViewport } from "../../../../app/util/mobileViewPort";
import { getPages, getPagesCount, toAbsoluteUrl } from "../../../_helpers";

const useStyles = makeStyles((theme) => ({
  textField: {
    marginRight: "10px",
    marginLeft: "10px",
    width: "36px",
    height: "25px",
    backgroundColor: "#f3f6f9",
    textAlign: "center",
    borderRadius: "4px",
    [theme.breakpoints.down("md")]: {
      width: (isMobile) => isMobile && "87px",
      height: (isMobile) => isMobile && "37px",
      border: (isMobile) => isMobile && "solid 1px #ccd6e3",
    },
  },
}));

const sizePerPageOptions = [
  {
    text: "10",
    value: 10,
  },

  {
    text: "25",
    value: 25,
  },

  {
    text: "50",
    value: 50,
  },
];
export default function CustomPagination({
  onPageSizeAndPageChange = () => {},
  sizePerPageList = sizePerPageOptions,
  totatCount,
}) {
  const isMobile = useMobileViewport();
  const classes = useStyles(isMobile);

  const [currentPage, setCurrentPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(DEAFAULT_PAGESIZE);

  const pagesCount = getPagesCount(totatCount, sizePerPage);
  const pages = getPages(currentPage, pagesCount, sizePerPage);

  useEffect(() => {
    if (isMobile) {
    }
  }, [isMobile]);

  const togglePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };
  const toggleNext = () => {
    if (currentPage < pagesCount && currentPage > 0) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const resetPages = () => {
    setCurrentPage(1);
  };

  const onSizeChange = (event) => {
    const newPageSize = +event.target.value;
    setCurrentPage(1);
    setSizePerPage(newPageSize);
  };

  useEffect(() => {
    resetPages();
  }, [totatCount]);

  useEffect(() => {
    if (currentPage !== "")
      onPageSizeAndPageChange(sizePerPage, currentPage);
  }, [sizePerPage, currentPage]);

  const handleInputChange = (value) => {
    if (isNaN(value) || value > pagesCount) return;
    if (value === 0) {
      setCurrentPage("");
      return;
    }
    setCurrentPage(value);
  };

  const blockInvalidChar = (e) => [".", "e", "E", "+", "-"].includes(e.key) && e.preventDefault();

  return (
    <>
      {totatCount && totatCount > 0 ? (
        <div
          className={`pt-2 d-flex justify-content-between ${clsx({
            "flex-column-reverse": isMobile,
          })}`}
        >
          <div
            className={`d-flex align-items-center  ${clsx({
              "justify-content-center mt-8 ml-n4": isMobile,
              "mx-10": !isMobile,
            })}`}
          >
            {!isMobile && (
              <>
                <span>Show</span>
                <select
                  name="pageSize"
                  className={`ml-4 form-control form-control-sm font-weight-bold mr-4 border-0 bg-light`}
                  value={sizePerPage}
                  onChange={onSizeChange}
                  style={{
                    width: "75px",
                  }}
                >
                  {sizePerPageList.map((option) => {
                    return (
                      <option
                        key={option.text}
                        value={option.page}
                        className={`btn `}
                      >
                        {option.text}
                      </option>
                    );
                  })}
                </select>
                <span className="mr-10">entries </span>
              </>
            )}

            <span>
              {!isMobile && currentPage} Out of {pagesCount}
            </span>
          </div>
          <div
            className={`d-flex ${clsx({
              "flex-grow-1 justify-content-between px-10": isMobile,
              "mr-15": !isMobile,
            })}`}
          >
            <a
              href={() => false}
              onClick={() => togglePrevious()}
              className="btn btn-icon btn-sm btn-lightdd btn-hover-primarydd mr-2 my-1"
            >
              <SVG src={toAbsoluteUrl("/media/sr/icons/pagination-left.svg")} />
            </a>

            <div className="d-flex align-items-center">
              <Input
                id="pagei"
                label=""
                type="text"
                classes={{
                  root: classes.textField,
                }}
                onKeyPress={blockInvalidChar}
                autoComplete="off"
                disableUnderline={true}
                value={currentPage}
                onChange={(event) => {
                  handleInputChange(+event.target.value);
                }}
                inputProps={{
                  pattern: "[1-9]+",
                  style: { textAlign: "center" },
                }}
              />
            </div>
            <a
              href={() => false}
              onClick={() => toggleNext()}
              className="ml-5 btn btn-icon btn-sm btn-lightdd btn-hover-primarydd mr-2 my-1"
            >
              <SVG
                src={toAbsoluteUrl("/media/sr/icons/pagination-right.svg")}
              />
            </a>
          </div>
        </div>
      ) : null}
    </>
  );
}
